
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://dpvzaobiwvongwefgulm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRwdnphb2Jpd3Zvbmd3ZWZndWxtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5NzI3NzQsImV4cCI6MjA1NTU0ODc3NH0.gmpMYrhH5fARTARDgN8CDak_DY5ly5PuP4HCeFrGqCw";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
